import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import Text from '../../../Text'
import { checkHasBirdviewPortfolioOverdue } from '../BirdviewPortfolioRow.utils'

import * as styles from './BirdviewPortfolioRowMeta.module.css'

function BirdviewPortfolioRowMeta({ item }) {
  const { t } = useTranslation()

  return (
    <span className={styles.meta}>
      <Text isSecondary>
        {t('DashboardBirdview.OpenCountMetaKey', { count: item.open })}
      </Text>
      <Text isSecondary className={styles.dot}>
        ·
      </Text>
      <Text
        isSecondary
        className={classNames({
          [styles.alert]: checkHasBirdviewPortfolioOverdue(item),
        })}
      >
        {t('DashboardBirdview.OverdueCountMetaKey', { count: item.overdue })}
      </Text>
    </span>
  )
}

export default BirdviewPortfolioRowMeta
